import React from 'react';
import PropTypes from 'prop-types';
import { ifProp, switchProp } from 'styled-tools';
import styled, { css } from 'styled-components';
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';

const CheckboxLabel = styled(FormControlLabel)`
  .MuiFormControlLabel-label {
    ${switchProp('weight', {
      regular: css`
        font-weight: 400;
      `,
      medium: css`
        font-weight: 500;
      `,
      bold: css`
        font-weight: 700;
      `
    })}
  }
`;

const CheckboxInput = styled(Checkbox)`
  padding: 0.375rem;

  .MuiSvgIcon-root {
    font-size: 1.25rem;
  }
`;

const CheckboxAlignWrapper = styled('div')`
  ${ifProp({ $verticalAlign: 'top' }, css`
    align-self: flex-start;
    
    ${CheckboxInput} {
      padding-bottom: 0.125rem;
      padding-top: 0.125rem;
    }
  `)}
`;

const propTypes = {
  onChange: PropTypes.func,
  label: PropTypes.string,
  labelPlace: PropTypes.string,
  labelWeight: PropTypes.string,
  value: PropTypes.bool,
  verticalAlign: PropTypes.oneOf(['top', 'default'])
}

function CheckboxSingle({
  label,
  labelPlace,
  labelWeight = 'regular',
  value,
  onChange,
  verticalAlign = 'default'
}) {
  return (
    <FormControl variant='standard' component='fieldset'>
      <FormGroup aria-label={`checkbox for ${label}`}>
        <CheckboxLabel
          control={
            <CheckboxAlignWrapper $verticalAlign={verticalAlign}>
              <CheckboxInput
                name={label}
                checked={value}
                color='secondary'
                onChange={onChange}
              />
            </CheckboxAlignWrapper>
          }
          label={label}
          labelPlacement={labelPlace}
          value={label}
          weight={labelWeight}
        />
      </FormGroup>
    </FormControl>
  );
}

CheckboxSingle.propTypes = propTypes;

export default React.memo(CheckboxSingle);
